import React from 'react';
import { Select } from 'antd';
import useLanguageSelector from './languageSelector.hook';
import styles from './languageSelector.styles';

// Selector for lengaje for texts, not Dashboars language
export default function LanguageSelector({ onChange }) {
  const { languages, selectedLanguageCode, selectLanguage } = useLanguageSelector(onChange);

  return (
    <div style={styles.container}>
      <Select
        value={selectedLanguageCode}
        style={styles.selector }
        onChange={selectLanguage}
        bordered={false}
        placeholder="Select language"
      >
        {languages.map(language => (
          <Select.Option key={language.code} value={language.code}>
            {language.label}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
}
